module.exports = __webpack_public_path__ + "static/media/mastercard.d4ee19ac.png";